import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Row, Col, Navbar, Nav, NavItem } from 'react-bootstrap/lib';
import { history } from '../redux/store';

class ProjectHeader extends Component {
    render() {
        const { title, description, feature_img, role, context, period, link } = this.props.project;

        const bgStyle = "linear-gradient(135deg, rgba(226, 84, 255, 0.35) 25%, rgba(170, 0, 255, 0.75)), url('../" + feature_img + "') no-repeat center center fixed";

        return (
            <header className="hero" style={{ 'background': bgStyle }}>
                <Grid>
                    <Row>
                        <Col xs={12} md={6} mdOffset={6}>
                            <Navbar>
                                <Nav className="main-nav">
                                    <NavItem eventKey={1} onClick={() => { history.push('/') }}>Home</NavItem>
                                    <NavItem eventKey={2} href="#">Portfolio</NavItem>
                                    <NavItem eventKey={3} href="#">About</NavItem>
                                    <NavItem eventKey={4} href="#">Contact</NavItem>
                                </Nav>
                            </Navbar>
                            <div className="hero-text">
                                <h1><br />{title}</h1>
                                <h3>{description}</h3>
                                <br />
                                <h3 style={{'fontWeight': 'normal'}}><span className="blue">ROLE </span>{role}</h3>
                                <h3 style={{'fontWeight': 'normal'}}><span className="blue">CONTEXT </span>{context}
                                { link ? <a href={link} target="_blank" className="fa fa-external-link"> </a> : '' }</h3>
                                <h3 style={{'fontWeight': 'normal'}}><span className="blue">PERIOD </span>{period}</h3>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </header>
        );
    }
}

export default connect()(ProjectHeader);


// WEBPACK FOOTER //
// ./src/components/ProjectHeader.js